import React from "react";
import GridComponentWrapper from "components/grid/GridComponentWrapper";
import styled from "styled-components";
import {
  GridData,
  GridSheetData,
  GridSectionData,
  GridRowData,
  GridColumnData,
  GridCellData,
  CurrencyCellData,
  cellType
} from "components/grid/GridDataModel";
import { getUuid } from "@kubera/common";
import i18n from "i18next";

const GridContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 0;
  position: relative;
`;

const Grid = styled(GridComponentWrapper)`
  flex: 1;
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
`;

const getSkeletonLoaderRow = () => {
  const dateCell = new GridCellData(cellType.TEXT, "Date", null);
  dateCell.showSkeletonLoader = true;
  const valueCell = new CurrencyCellData(cellType.CURRENCY, "Value", null, "USD");
  valueCell.showSkeletonValueLoader = true;
  const optionsCell = new GridCellData(cellType.OPTIONS, "", null);
  optionsCell.hide = true;
  //optionsCell.showSkeletonLoader = true;
  const cells = [dateCell, valueCell, optionsCell];
  const rowData = new GridRowData(getUuid(), 1, "entry-id-" + Math.random(), cells, 0, false, () => true);
  return rowData;
};

const getEmptySection = (forIndex, sortKey, columnHeaders) => {
  const dateColumn = new GridColumnData(columnHeaders[0], true, false, false);
  const valueColumn = new GridColumnData(columnHeaders[1], true, false, false);
  const optionsColumn = new GridColumnData(null, true, false, true);

  const columns = [dateColumn, valueColumn, optionsColumn];

  //   if (this.props.isReadOnly === true) {
  //     columns.pop();
  //   }

  const sectionData = new GridSectionData(
    getUuid() + "-section",
    sortKey,
    "Section " + (forIndex + 1),
    [],
    columns,
    1,
    1,
    false
  );

  sectionData.showFooter = false;
  return sectionData;
};

const getEmptySheet = sortKey => {
  return new GridSheetData(getUuid() + "-sheet", sortKey, null, []);
};

const getGridData = (currency, columnHeaders) => {
  let rows = [];
  for (let i = 0; i < 5; i++) {
    rows.push(getSkeletonLoaderRow());
  }
  const section = getEmptySection(0, "1", columnHeaders);
  section.rows = rows;
  const sheet = getEmptySheet("1");
  sheet.sections = [section];

  const gridData = new GridData(currency, [sheet]);
  gridData.forceShowSheetsTitles = false;
  return gridData;
};

const GridSkeletonLoaderComponent = ({ columnHeaders = ["Date", "Value"] }) => {
  const gridData = getGridData(`USD`, columnHeaders);
  return (
    <GridContainer>
      <Grid title={i18n.t("assetsComponent.title")} gridData={gridData} />
    </GridContainer>
  );
};
export default GridSkeletonLoaderComponent;
